import { ModelTypes } from '@zeus';
import { bindable } from 'aurelia';

export class CardComponent {
  @bindable template: ModelTypes['newTemplateType'];
  @bindable action: () => Promise<void>;
}